import LongArrowRightIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/long-arrow-right';
import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { getSmAmenityIcon } from '../getIcon';

import type { HotelAmenityItem } from '@shared/types/hotel-content';

import STYLES from './SingleGroupAmenities.module.scss';

const cls = cssModules(STYLES);

const SingleGroupAmenities = ({ items }: { items: HotelAmenityItem[] }) => (
  <div
    data-test-id="single-amenities-group"
    className={cls('SingleGroupAmenities__amenities')}
  >
    {items.map(({ displayName: name, type }) => {
      const Icon = getSmAmenityIcon(type) ?? LongArrowRightIcon;
      return (
        <div className={cls('SingleGroupAmenities__amenity')} key={type}>
          <div className={cls('SingleGroupAmenities__icon')}>
            <Icon />
          </div>
          <BpkText tag="p" className={cls('SingleGroupAmenities__name')}>
            {name}
          </BpkText>
        </div>
      );
    })}
  </div>
);

export default SingleGroupAmenities;
